export const FETCH_FEE_GROUPS_START = "FETCH_FEE_GROUPS_START";
export const FETCH_FEE_GROUPS_SUCCESS = "FETCH_FEE_GROUPS_SUCCESS";
export const API_ERROR = "API_ERROR";
export const ADD_FEES_GROUPS_START = "ADD_FEES_GROUPS_START";
export const ADD_FEES_GROUP_SUCCESS = "ADD_FEES_GROUP_SUCCESS";
export const EDIT_FEE_GROUP_START = "EDIT_FEE_GROUP_START";
export const EDIT_FEE_GROUP_SUCCESS = "EDIT_FEE_GROUP_SUCCESS";
export const DELETE_FEE_GROUP_START = "DELETE_FEE_GROUP_START";
export const DELETE_FEE_GROUP_SUCCESS = "DELETE_FEE_GROUP_SUCCESS";
export const ADD_MODAL_CLEAR = "ADD_MODAL_CLEAR";
export const EDIT_MODAL_CLEAR = "EDIT_MODAL_CLEAR";
export const DELETE_MODAL_CLEAR = "DELETE_MODAL_CLEAR";